
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { cn } from '@/lib/utils';

const NAV_LINKS = [
  { label: 'Découvrir', to: '/search' },
  { label: 'Comment ça marche', to: '/about' },
  { label: 'Pour les pros', to: '/pro' },
  { label: 'Blog', to: '/blog' },
];

const NavLinks: React.FC = () => {
  const { isProfessional } = useAuth();
  const { pathname } = useLocation();

  return (
    <div className="hidden md:flex items-center gap-7">
      {NAV_LINKS.map(({ label, to }) => {
        const active = pathname === to || (to !== '/' && pathname.startsWith(to));
        return (
          <Link
            key={to}
            to={to}
            className={cn(
              'text-sm font-medium pb-1 border-b-2 transition-colors duration-200 ease-brand whitespace-nowrap',
              active
                ? 'text-brand-primary border-brand-primary'
                : 'text-brand-text-muted hover:text-brand-primary border-transparent'
            )}
          >
            {label}
          </Link>
        );
      })}
      {isProfessional && (
        <Link
          to="/pro-dashboard"
          className="text-sm font-semibold text-brand-primary hover:text-brand-primary-600 border-b-2 border-brand-primary pb-1 transition-colors duration-200"
        >
          Espace Pro
        </Link>
      )}
    </div>
  );
};

export default NavLinks;
